import { css } from '@emotion/core'
import { SerializedStyles } from '@emotion/react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as React from 'react'

import { breakpoints } from '../constants/breakPoints'
import { TemplateViewProps } from '../interfaces/templates'
import PaginationBlock from './PaginationBlock'
import SVGIcon from './SvgIcon'
import ViewsDropdown from './ViewsDropdown'

interface TemplateViewsBlockProps {
  views: TemplateViewProps[]
  cssStyles?: SerializedStyles
}

const TemplateViewsBlock: React.FunctionComponent<TemplateViewsBlockProps> = ({ views, cssStyles }) => {
  const [currentItem, setCurrentItem] = React.useState(0)

  return (
    <div css={[containerStyle, cssStyles]}>
      <div css={tabsContainerStyle(views.length)}>
        {views.map(({ iconName, name }, index) => {
          const selectedItem = currentItem === index
          return (
            <div
              key={index}
              className={`subtitle ${!selectedItem ? 'opacity-on-hover' : ''}`}
              onClick={() => setCurrentItem(index)}
              css={selectedItem && currentTabStyle(iconName)}
            >
              {iconName && <SVGIcon src={`templates/${iconName}`} />} {name}
            </div>
          )
        })}
      </div>
      <ViewsDropdown
        items={views}
        currentItem={currentItem}
        setCurrentItem={setCurrentItem}
        cssStyles={dropdownStyle}
      />
      <div className="gray-bordered-block">
        <GatsbyImage
          image={views[currentItem].preview.gatsbyImageData}
          className="fade-in-left"
          alt={views[currentItem].name}
        />
      </div>
      <PaginationBlock
        circlesQuantity={views.length}
        currentSelection={currentItem}
        setCurrentSelection={setCurrentItem}
      />
    </div>
  )
}

export default TemplateViewsBlock

const containerStyle = css`
  margin-bottom: 4rem;
`

const tabsContainerStyle = (viewsLength: number) => css`
  display: flex;
  ${viewsLength > 4 && 'justify-content: space-between'};
  border-bottom: 1px solid #efeff0;
  margin-bottom: 2rem;

  .subtitle {
    margin: 0;
    padding: 1.5rem 0 0.375rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-bottom: 2px solid transparent;

    svg {
      margin-right: 0.5rem;
    }

    ${viewsLength < 5 && '&:not(:last-child) {margin-right: 3rem;}'};
  }

  @media screen and (max-width: ${breakpoints.small}px),
    (min-width: ${breakpoints.medium + 1}px) and (max-width: 999px) {
    display: none;
  }
`

const currentTabStyle = (iconName?: string) => css`
  color: #318eff;
  border-bottom: 2px solid #318eff !important;

  ${iconName === 'inbox_view_small'
    ? `svg > path:nth-child(2) {
    fill: #318eff;
  }`
    : `svg > path:first-child {
    fill: #318eff;
  }`}
`

const dropdownStyle = css`
  margin: 1rem 0;
  max-width: 50%;

  @media screen and (min-width: ${breakpoints.small + 1}px) and (max-width: ${breakpoints.medium}px),
    (min-width: 1000px) {
    display: none;
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    max-width: 100%;
  }
`
